import React, { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import { APP_LINK_TARGETS, androidIntentUrl, isAndroid } from "../utils/appLink";

/*
 * /app/:target — the https landing for the daily fleet summary's WhatsApp / email button
 * (WhatsApp URL buttons can't carry the app's yekkada:// scheme). On Android it opens the Yekkada
 * app at the matching screen (Play Store if it isn't installed); elsewhere it shows the web page.
 * Public route on purpose: the app does its own sign-in, and the web page it falls back to is
 * guarded as usual.
 */
export default function OpenInApp() {
  const { target } = useParams();
  const known = APP_LINK_TARGETS[target];
  const android = isAndroid(typeof navigator !== "undefined" ? navigator.userAgent : "");
  const intentUrl = known ? androidIntentUrl(target) : null;

  useEffect(() => {
    if (android && intentUrl) window.location.replace(intentUrl);
  }, [android, intentUrl]);

  if (!known) return <Navigate to="/" replace />;
  if (!android) return <Navigate to={known.webPath} replace />;

  // Shown while Android switches to the app — and as a tap target in case a browser (some
  // in-app browsers) only allows opening an app from a user tap.
  return (
    <div style={{ maxWidth: 420, margin: "72px auto", padding: "0 16px", textAlign: "center",
                  fontFamily: "Arial, sans-serif", color: "#333" }}>
      <img src="/yekkada-logo.png" alt="Yekkada" width="160" style={{ display: "block", margin: "0 auto 24px" }} />
      <p style={{ fontSize: 16, marginBottom: 24 }}>Opening the Yekkada app…</p>
      <a href={intentUrl}
         style={{ display: "inline-block", background: "#363166", color: "#fff", padding: "12px 22px",
                  borderRadius: 6, fontWeight: "bold", textDecoration: "none" }}>
        Open Yekkada app
      </a>
      <p style={{ marginTop: 20, fontSize: 14 }}>
        <a href={known.webPath} style={{ color: "#1f4fcc", textDecoration: "none" }}>Continue on the web instead</a>
      </p>
    </div>
  );
}
